export const INTERNAL_REVIEW_ACTION_TYPE = {
  APPROVE: "approve",
  COMPLETE: "complete",
  REJECT: "reject",
  CHANGE_ASSIGNEE: "changeAssignee",
  EXTEND: "extend",
};
